import React from "react";
import PropTypes from "prop-types";
import chevron from "@common/images/chevron.svg";
import chevronDisabled from "@common/images/chevron-disabled.svg";
import { Image } from "@learningblocks/shared-components";
import { Button } from "../Button";

import { useTranslation } from "react-i18next";

import style from "./style.module.scss";

export function VagueStepper(props) {
  const {
    t,
    // i18n
  } = useTranslation("translation");

  const underflow = () => props.currentValue === props.min;
  const overflow = () => props.currentValue === props.max;

  const leftButtonNormal = () => (
    <>
      <Image
        className={style.stepperVague_chevronLeft}
        src={chevron}
        role="presentation"
        onContextMenu={(e) => {
          e.preventDefault();
        }}
      />
      {props.mobileControls ? (
        <span>{t(`${props.mobileControls.leftText}.string`)}</span>
      ) : null}
    </>
  );

  const leftButtonDisabled = () => (
    <>
      <Image
        className={style.stepperVague_chevronLeft}
        src={chevronDisabled}
        role="presentation"
        onContextMenu={(e) => {
          e.preventDefault();
        }}
      />
      {props.mobileControls ? (
        <span>{t(`${props.mobileControls.leftText}.string`)}</span>
      ) : null}
    </>
  );

  const rightButtonNormal = () => (
    <>
      {props.mobileControls ? (
        <span>{t(`${props.mobileControls.rightText}.string`)}</span>
      ) : null}
      <Image
        className={style.stepperVague_chevronRight}
        src={chevron}
        role="presentation"
        onContextMenu={(e) => {
          e.preventDefault();
        }}
      />
    </>
  );

  const rightButtonDisabled = () => (
    <>
      {props.mobileControls ? (
        <span>{t(`${props.mobileControls.rightText}.string`)}</span>
      ) : null}
      <Image
        className={style.stepperVague_chevronRight}
        src={chevronDisabled}
        role="presentation"
        onContextMenu={(e) => {
          e.preventDefault();
        }}
      />
    </>
  );

  const timerRight = React.useRef(null);
  const timerLeft = React.useRef(null);
  const [currentVal, setCurrentVal] = React.useState(props.currentValue);
  let counter = 0;
  let currVal = props.currentValue;

  React.useEffect(() => {
    setCurrentVal(props.currentValue);
  }, [props.currentValue]);

  const holdingRight = () => {
    if (currVal === props.max) {
      clearTimeout(timerRight.current);
    } else {
      if (props.keyboardStep !== "auto") {
        props.onChange(
          Number((currentVal + props.step + counter * props.step).toFixed(6))
        );
        currVal = Number(
          (currentVal + props.step + counter * props.step).toFixed(6)
        );
      } else if (
        props.ariaInterval + counter < props.altTextData.length - 1 &&
        props.altTextData[props.ariaInterval + 1 + counter].keyboardStep !== ""
      ) {
        props.onChange(
          Number(
            parseFloat(
              props.altTextData[props.ariaInterval + 1 + counter].keyboardStep
            ).toFixed(6)
          )
        );
        currVal = Number(
          parseFloat(
            props.altTextData[props.ariaInterval + 1 + counter].keyboardStep
          ).toFixed(6)
        );
      } else {
        clearTimeout(timerRight.current);
      }
      counter++;
      if (counter > 25) {
        timerRight.current = setTimeout(holdingRight, 25);
      } else if (counter > 7) {
        timerRight.current = setTimeout(holdingRight, 100);
      } else {
        timerRight.current = setTimeout(holdingRight, 250);
      }
    }
  };

  const releaseRight = () => {
    counter = 0;
    clearTimeout(timerRight.current);
  };

  const holdingLeft = () => {
    if (currVal === props.min) {
      clearTimeout(timerLeft.current);
    } else {
      if (props.keyboardStep !== "auto") {
        props.onChange(
          Number((currentVal - props.step - counter * props.step).toFixed(6))
        );
        currVal = Number(
          (currentVal - props.step - counter * props.step).toFixed(6)
        );
      } else if (
        props.keyboardStep === "auto" &&
        props.ariaInterval - counter !== 0 &&
        props.altTextData[props.ariaInterval - 1 - counter].keyboardStep !== ""
      ) {
        props.onChange(
          Number(
            parseFloat(
              props.altTextData[props.ariaInterval - 1 - counter].keyboardStep
            ).toFixed(6)
          )
        );
        currVal = Number(
          parseFloat(
            props.altTextData[props.ariaInterval - 1 - counter].keyboardStep
          ).toFixed(6)
        );
      } else {
        clearTimeout(timerLeft.current);
      }
      counter++;
      if (counter > 25) {
        timerLeft.current = setTimeout(holdingLeft, 25);
      } else if (counter > 7) {
        timerLeft.current = setTimeout(holdingLeft, 100);
      } else {
        timerLeft.current = setTimeout(holdingLeft, 250);
      }
    }
  };

  const releaseLeft = () => {
    counter = 0;
    clearTimeout(timerLeft.current);
  };

  return (
    <>
      <Button
        className={style.stepperVague}
        onMouseDown={holdingLeft}
        onMouseUp={releaseLeft}
        // onTouchStart={holdingLeft} onTouchEnd={releaseLeft}
        onKeyDown={(e) => {
          if (e.repeat) {
            return;
          }
          const keycode = e.keyCode ? e.keyCode : e.which;
          if (keycode === 13) {
            holdingLeft();
          }
        }}
        onKeyUp={(e) => {
          const keycode = e.keyCode ? e.keyCode : e.which;
          if (keycode === 13) {
            releaseLeft();
          }
        }}
        disabled={underflow()}
        normalicon={leftButtonNormal()}
        disabledicon={leftButtonDisabled()}
        ariaLabel={t("sliderLeft.string")}
      />
      <div style={{ width: "2px" }}></div>
      <Button
        className={style.stepperVague}
        onMouseDown={holdingRight}
        onMouseUp={releaseRight}
        // onTouchStart={holdingRight} onTouchEnd={releaseRight}
        onKeyDown={(e) => {
          if (e.repeat) {
            return;
          }
          const keycode = e.keyCode ? e.keyCode : e.which;
          if (keycode === 13) {
            holdingRight();
          }
        }}
        onKeyUp={(e) => {
          const keycode = e.keyCode ? e.keyCode : e.which;
          if (keycode === 13) {
            releaseRight();
          }
        }}
        disabled={overflow()}
        normalicon={rightButtonNormal()}
        disabledicon={rightButtonDisabled()}
        ariaLabel={t("sliderRight.string")}
      />
    </>
  );
}

VagueStepper.propTypes = {
  /**
   * lowest value possible
   */
  min: PropTypes.number,
  /**
   * highest value possible
   */
  max: PropTypes.number,
  /**
   * current value
   */
  currentValue: PropTypes.number,
  /**
   * increment/decremnet step
   */
  step: PropTypes.number,
};
